import React, { Component } from 'react';
import { connect } from 'react-redux';

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';

import * as userStationsReducers from '../../system/reducer/UserStationsReducers';
import * as downloadRequestReducers from '../../download-request/reducer';
import * as slowDataReducers from '../reducer';

import * as slowDataActionMgr from '../action-mgr';
import * as downloadRequestActionMgr from '../../download-request/action-mgr';

import * as strings from '../../helpers/strings';
import { getFastDataStationId } from '../../helpers/common';
// importing Css
import '../../index.css';
const styles = {
  graphViewButton: { height: 30, border: "1px solid rgba(0,0,0,0.5)", lineHeight: "30px", paddingLeft: 16, paddingRight: 16 },
  selected: { background: "rgba(0,0,0,0.1)" }
}

var defaultStation, defaultStationId;
var oneTime = 0
class DMYLineGraphScreen extends Component {

  constructor() {
    super();
    this.handleSelectField = this.handleSelectField.bind(this);
    this.handleSelectFieldFilter = this.handleSelectFieldFilter.bind(this);

    this.state = {
      selectFilter: 'all',
      oneTimeRun: false
    }
  }

  componentDidMount() {
    const { stations, getFindStationFields, fetchDownloadAvaliableTime } = this.props;

    if (stations.length > 0) {
      if (stations.filter(station => station.id === getFastDataStationId()).length !== 0) {
        defaultStation = stations.filter(station => station.id === getFastDataStationId())[0].name;
        defaultStationId = stations.filter(station => station.id === getFastDataStationId())[0].id;
      } else {
        defaultStation = stations[0].name;
      }
      getFindStationFields(defaultStation);

      fetchDownloadAvaliableTime(defaultStation)
    }
  }

  shouldComponentUpdate() {


    return true;
  }

  handleSelectField(e) {
    const { setSelectedField } = this.props;
    setSelectedField(e.target.value);
  }

  handleSelectFieldFilter(e) {
    this.setState({ selectFilter: e.target.value })
  }

  render = () => {
    const { findStationFields, selectedField,resetSelectFields  } = this.props;

    // Determine if the "Clear" button should be disabled
    const isClearButtonDisabled = selectedField.length === 0;
    return (
      <Paper >
        <Table className="filterParamTable">
          <TableHead>
            <TableRow >
                <div className='params'>
                  <div className='paramLabels'>
                    <p className='paramName'>
                      {strings.lblParametersName}
                    </p>
                    <p className='paramType'>
                      {strings.lblParametersType}
                    </p>

                  </div>
                  <div className='filterParamType'>
                  <Button 
                      variant="contained"
                      color={strings.colorPrimary}
                      size="small"
                      style={{
                        position: 'relative'
                      }}
                      disabled={isClearButtonDisabled} // Disable the button if no fields are selected
                      onClick={resetSelectFields}
                    >
                      Clear
                    </Button>
                    <FormControl margin={strings.txtNormal}>
                      <Select
                        value={this.state.selectFilter}
                        onChange={this.handleSelectFieldFilter}
                        style={{ fontSize: "11px" }}
                      >
                        {(() => {
                          const options = [];
                          const filterTypes = ['all'];
                          options.push(<MenuItem value={'all'}>All</MenuItem>)
                          Object.entries(findStationFields).forEach(([key, value]) => {
                            if (value !== "" && filterTypes.indexOf(value) === -1 && key !== "irradiance_field") {
                              options.push(
                                <MenuItem value={value}>{value}</MenuItem>
                              )
                              filterTypes.push(value);
                            }
                          });
                          return options;
                        })()}
                      </Select>
                    </FormControl>
                  </div>
                </div>
            </TableRow>
          </TableHead>
        </Table >

        <div className="filterFieldsTableWrapper">
          <Table className="filterFieldsTable">
            <TableBody>
              {(() => {
                const options = [];
                Object.entries(findStationFields).forEach(([key, value]) => {

                  if (((value !== "" && this.state.selectFilter === "all") || this.state.selectFilter === value) && key !== "irradiance_field") {
                    options.push(
                      <TableRow>
                        <TableCell>
                          <FormControlLabel
                            key={key}
                            control={
                              <Checkbox
                                checked={(selectedField.includes(key) ? true : false)}
                                value={key}
                                color={strings.colorPrimary}
                                onClick={this.handleSelectField} />
                            }
                            label={key}
                          />
                        </TableCell>
                        <TableCell>
                          {value}
                        </TableCell>
                      </TableRow>
                    );
                  }
                });
                return options;
              })()}

            </TableBody>
          </Table>
        </div>
      </Paper>
    );
  }
}

const mapStateToProps = state => ({
  stations: userStationsReducers.getStations(state),
  findStationFields: slowDataReducers.getFindStationFields(state),
  selectedField: slowDataReducers.getSelectedField(state),

  getStnAvaliableTime: downloadRequestReducers.getStnAvaliableTime(state)
});

const mapActionsToProps = {
  getFindStationFields: slowDataActionMgr.getFindStationFields,
  setSelectedField: slowDataActionMgr.selectFields,
  fetchDownloadAvaliableTime: downloadRequestActionMgr.fetchDownloadAvaliableTime,
  resetSelectFields: slowDataActionMgr.resetSelectFields, // Added action
  getQueryHistoryData: slowDataActionMgr.getQueryHistoryData,
  selectDay: slowDataActionMgr.selectDay,
  selectYear: slowDataActionMgr.selectYear,
  selectMonth: slowDataActionMgr.selectMonth,

};

export default connect(mapStateToProps, mapActionsToProps)(
  withStyles(styles)(DMYLineGraphScreen)
);